import { OLDER_HISTORY } from "./reviewCodes";

export function copySource(detail: string): {
  store: string | null;
  field: string | null;
} {
  const [source, field] = detail.split(" · ").map((part) => part.trim());
  return {
    store: source && source !== OLDER_HISTORY ? source : null,
    field: source ? field || null : null,
  };
}
